import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";
import * as types from "../../sdk/types/api";
import { TIngredientPayload } from "../../sdk/utils/api/ingredients";

export const useUpdateIngredient = (
    invalidQueryKeys: string | (string | number)[],
): UseMutationResult<types.IIngredient, unknown, { ingredientId: string; body: TIngredientPayload }> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<types.IIngredient, unknown, { ingredientId: string; body: TIngredientPayload }>({
        mutationFn: async (parameters: { ingredientId: string; body: TIngredientPayload }) => {
            if (!auth.token) {
                throw new Error("Cannot save without authorization token.");
            }
            return await api.Ingredients.update(parameters.ingredientId, parameters.body, auth.token);
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
